import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";

import logo from "../assets/img/LogoFree.svg";
import "../assets/css/cs.css";

const meta = {
  title: "Cancellation & Refund - Logy.AI",
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function CancellationRefund() {
  const [menu, setMenu] = useState(true);
  const toggleMenu = () => {
    setMenu(!menu);
  };
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <section className="pt-6 bg-gray-50 overflow-hidden pb-6">
        <div className="container mx-auto px-4">
          <div className="mb-1">
            <div className="flex items-center justify-between px-6 py-3.5 bg-white border border-gray-100 rounded-full">
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto">
                    <Link className="inline-block" to="/">
                      <img
                        src={logo}
                        style={{
                          width: "100px",
                          transform: "translateY(3px) translateX(10px)",
                        }}
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto hidden lg:block">
                    <ul className="flex items-center justify-center ">
                      <li className="  ">
                        <Link
                          to="/about"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          About Us
                        </Link>
                      </li>
                      <li className="  ">
                        <Link
                          to="/products"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Products
                        </Link>
                      </li>
                      <li className="  ">
                        <Link
                          to="/articles"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Articles
                        </Link>
                      </li>
                      <li className="  ">
                        <Link
                          to="/cases"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Case Studies
                        </Link>
                      </li>
                      <li className="mr-9   ">
                        <Link
                          to="/contact"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="w-auto lg:hidden">
                    <button
                      className="inline-block"
                      onClick={() => toggleMenu()}
                    >
                      <svg
                        className="navbar-burger text-gray-800"
                        width={45}
                        height={45}
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width={56}
                          height={56}
                          rx={28}
                          fill="currentColor"
                        />
                        <path
                          d="M37 32H19M37 24H19"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${menu ? "hidden" : ""} navbar-menu fixed top-0 left-0 bottom-0 w-4/6 sm:max-w-xs z-50`}
            >
              <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-80" />
              <nav className="relative z-10 px-9 py-8 bg-white h-full overflow-y-auto">
                <div className="flex flex-wrap justify-between h-full">
                  <div className="w-full">
                    <div className="flex items-center justify-between -m-2">
                      <div className="w-auto p-2">
                        <Link className="inline-block" to="/">
                          <img
                            src={logo}
                            style={{ width: "100px" }}
                            alt=""
                          />
                        </Link>
                      </div>
                      <div className="w-auto p-2">
                        <button
                          className="inline-block navbar-burger"
                          onClick={() => toggleMenu()}
                        >
                          <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 18L18 6M6 6L18 18"
                              stroke="#111827"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center py-8 w-full">
                    <ul>
                      <li className="mb-12">
                        <Link
                          to="/about"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          About Us
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/products"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Products
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/articles"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Articles
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/cases"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Case Studies
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/contact"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <div className="container mx-auto mt-8 px-4 pb-16">
        <div className="flex justify-center pt-10">
          <div className="max-w-4xl bg-white p-8 rounded-lg">
            <h1 className="text-5xl font-bold mb-8 text-center text-gray-900">
              Cancellation & Refund Policy
            </h1>
            
            <p className="text-gray-600 text-lg mb-8">
              Effective Date: January 1, 2024
            </p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">1. Overview</h2>
                <p className="text-gray-700 leading-relaxed">
                  This Cancellation and Refund Policy applies to Logy.AI's software subscriptions and services. We offer different terms for our B2B enterprise clients and individual user subscriptions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">2. B2B Enterprise Agreements</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  For our B2B enterprise clients, cancellation and refund terms are governed by the specific bespoke agreements entered into between Logy.AI and the client organization. These terms may include:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Custom cancellation notice periods</li>
                  <li>Service level agreements (SLAs)</li>
                  <li>Specific refund conditions</li>
                  <li>Contract-specific termination clauses</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  Please refer to your specific enterprise agreement for applicable terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">3. User Subscriptions</h2>
                <h3 className="text-xl font-semibold mb-3 text-gray-900">3.1 No Refund Policy</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  For individual user subscriptions to Logy.AI services, we maintain a strict no-refund policy. All subscription fees are non-refundable once payment has been processed.
                </p>
                
                <h3 className="text-xl font-semibold mb-3 text-gray-900">3.2 Cancellation Terms</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Users may cancel their subscription at any time through their account settings. Upon cancellation:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Access to services will continue until the end of the current billing period</li>
                  <li>No refunds will be provided for unused time in the billing period</li>
                  <li>Auto-renewal will be disabled</li>
                  <li>Data retention will follow our Privacy Policy guidelines</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">4. Free Trials</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you are using a free trial, you may cancel at any time during the trial period without any charges. If you do not cancel before the trial period ends, you will be automatically charged for the subscription plan you selected, and no refund will be available.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">5. Service Modifications</h2>
                <p className="text-gray-700 leading-relaxed">
                  Logy.AI reserves the right to modify or discontinue services with reasonable notice. In the event of service discontinuation, affected users will receive pro-rated refunds for any prepaid unused period.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">6. Exceptions</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Refunds may be considered on a case-by-case basis only in the following circumstances:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Technical issues preventing service access that cannot be resolved by our support team</li>
                  <li>Duplicate charges due to system error</li>
                  <li>Charges made without authorization</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">7. How to Cancel</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  To cancel your subscription:
                </p>
                <ol className="list-decimal list-inside text-gray-700 space-y-2 ml-4">
                  <li>Log in to your Logy.AI account</li>
                  <li>Navigate to Account Settings</li>
                  <li>Select Subscription Management</li>
                  <li>Click on Cancel Subscription</li>
                  <li>Follow the prompts to confirm cancellation</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">8. Contact Information</h2>
                <p className="text-gray-700 leading-relaxed">
                  For questions about this Cancellation and Refund Policy or to request support, please contact us at:
                </p>
                <div className="mt-4 text-gray-700">
                  <p>Email: support@logy.ai</p>
                  <p>Phone: +91-700197-(two zero one six)</p>
                  <p>Address: Logy.AI, Inc., Healthcare Innovation Hub, San Francisco, CA 94105</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">9. Policy Updates</h2>
                <p className="text-gray-700 leading-relaxed">
                  This policy may be updated from time to time. We will notify users of any material changes via email or through our platform. Continued use of our services after such modifications constitutes acceptance of the updated policy.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}